import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BuiltByScience,
  CustomerReviews,
  CustomerReviewsDesc,
  Faq,
  GlutenFree,
  HereMainHeading,
  HereMainHeading2,
  NoArtificialCloning,
  SatisfactionGuaranteeDesc,
  SatisfactionGuaranteeTitle,
  SuitableForAthletes,
  Vegan,
} from '../../../Constants';
import VeganImg from '../../../assets/vegan.webp';
import GlutenFreeImg from '../../../assets/gluten-free.webp';
import NoArtificialColoringImg from '../../../assets/no-additives.webp';
import SuitableForAthletesImg from '../../../assets/suitable-for-athletes-doping-free.webp';
import TeamImg from '../../../assets/ale-and-paul.webp';
import GuaranteeImg from '../../../assets/Guarantee.webp';
import ProductSuggestionWhyRiise from '../ProductSuggestionWhyRiise';
import ExpertSection from './ExpertSection';
import ReviewsMobile from './ReviewsMobile';
import HereForYou from './HereForYou';
import HowToEnjoy from './HowToEnjoy';
import NutrientClashSection from './NutrientClashSection';
import MakeChoice from '../../Home/MakeChoice';
import PersonalFormulasSection from '../../Home/PersonalFormulasSection';
import HighStandards from '../../Home/HighStandards';
import PractitionerBadge from './PractitionerBadge';
import Made from '../../Home/Made';

const ProductPageSections = ({
  lang,
  rating,
  reviewsRef,
  excludedFaqTitleKeys = [],
}) => {
  const { t } = useTranslation();
  const qualityItems = [
    { title: t(Vegan), image: VeganImg },
    { title: t(GlutenFree), image: GlutenFreeImg },
    { title: t(NoArtificialCloning), image: NoArtificialColoringImg },
    { title: t(SuitableForAthletes), image: SuitableForAthletesImg },
  ];

  return (
    <div className="t-flex t-flex-col t-gap-8 t-py-4 t-pb-40">
      <div className="t-w-full t-max-w-[500px] t-mx-auto !t-px-4">
        <HowToEnjoy />
      </div>
      <PersonalFormulasSection rating={rating} />
      <div className="t-w-full t-max-w-[700px] t-mx-auto t-flex t-flex-col t-gap-4 t-overflow-auto md:t-min-h-[406px]">
        <h2 className="t-text-center !t-m-0 t-px-4 t-font-serif t-font-normal t-text-navy">
          {t(BuiltByScience)}
        </h2>
        <ExpertSection lang={lang} />
        <HighStandards />
        <div className="t-flex t-justify-center t-px-4">
          <PractitionerBadge />
        </div>
      </div>

      <div className="t-bg-g100 t-p-4">
        <div
          className="t-w-full t-max-w-[1320px] t-mx-auto t-flex t-flex-col t-gap-2 t-overflow-auto"
          ref={reviewsRef}
        >
          <h2 className="t-text-center !t-m-0 t-font-serif t-font-normal t-text-navy">
            {t(CustomerReviews)}
          </h2>
          <p className="t-text-center !t-m-0 t-font-sans t-text-[15px] t-text-navy/70">
            {t(CustomerReviewsDesc)}
          </p>
          <ReviewsMobile />
        </div>
      </div>
      <NutrientClashSection />
      <div className="t-max-w-[600px] t-mx-auto t-flex t-flex-col t-gap-4 t-px-4">
        <MakeChoice isProductPage />
      </div>
      <div className="t-bg-g100 t-p-4">
        <div className="t-w-full t-max-w-[600px] t-flex t-items-start t-justify-between t-gap-4 t-mx-auto">
          {qualityItems.map((item) => (
            <div
              className="t-flex-none t-w-1/6 t-flex t-flex-col t-items-center t-justify-center t-gap-1"
              key={`unique-${item.title}`}
            >
              <img src={item.image} alt="" height={40} width={40} />
              <p className="t-m-0 t-text-xs md:t-text-sm t-text-center t-font-sans t-text-navy/60 t-leading-4">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="t-w-full t-max-w-[500px] t-mx-auto t-px-2">
        <h2 className="t-text-center !t-m-0 t-font-serif t-font-normal t-text-navy">{t(Faq)}</h2>
        <ProductSuggestionWhyRiise
          pickedFaqsShow
          excludedFaqTitles={excludedFaqTitleKeys.map((key) => t(key))}
        />
      </div>
      <div className="t-max-w-[600px] t-mx-auto t-flex t-flex-col t-gap-4 t-px-4">
        <div>
          <h2 className="t-text-center !t-m-0 t-font-serif t-font-normal t-text-navy">
            {t(HereMainHeading)}
          </h2>
          <h2 className="t-text-center !t-m-0 t-font-serif t-font-normal t-text-navy">
            {t(HereMainHeading2)}
          </h2>
        </div>
        <HereForYou isProductPage />
      </div>
      <div className="t-w-full t-max-w-[600px] t-mx-auto t-px-4">
        <div className="t-flex t-flex-row t-items-center t-gap-4 t-rounded-xl t-border t-border-g200 t-bg-white t-p-3 sm:t-p-4">
          <img
            src={TeamImg}
            alt=""
            className="t-h-24 t-w-24 sm:t-h-28 sm:t-w-28 t-flex-none t-rounded-lg t-object-cover"
          />
          <div className="t-flex t-flex-col t-gap-1.5">
            <div className="t-flex t-items-center t-gap-2">
              <img src={GuaranteeImg} alt="" className="t-h-5 t-w-5 t-flex-none" />
              <h3 className="!t-m-0 t-font-serif t-font-normal t-text-navy t-text-lg sm:t-text-xl">
                {t(SatisfactionGuaranteeTitle)}
              </h3>
            </div>
            <p className="!t-m-0 t-font-sans t-text-[14px] t-text-navy/70">
              {t(SatisfactionGuaranteeDesc)}
            </p>
            <Made />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPageSections;
